<template>
<!--  <a-button size="small" type="primary" @click="showModal"-->
<!--            :disabled="!canEdit">{{ $t("edit") }}</a-button>-->
  <a-menu-item :disabled="!canEdit" @click="showModal">
    <a href="javascript:;">{{ $t("edit") }}</a>
  </a-menu-item>
  <a-modal v-model:visible="visible"
           :title="$t('edit')"
           style="width: 60%;top: 20px"
           :ok-text="$t('submit')"
           :cancel-text="$t('cancel')"
           @ok="handleOk"
  >
    <a-form
        ref="taskForm"
        :model="task"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
    >
      <a-form-item
          :label="$t('animalType')"
          name="animaltype"
          :rules="[{ required: true, message: $t('pleaseSelect') + $t('animalType') }]"
      >
        <select-id-and-name :list="animalTypeList" option-value="id" option-text="name"
                            v-model:value="task.animaltype"></select-id-and-name>
      </a-form-item>
      <a-form-item
          :label="$t('geneName')"
          name="genename"
          :rules="[{ required: true, message: $t('pleaseEnter') + $t('geneName') }]"
      >
        <a-input v-model:value="task.genename"/>
      </a-form-item>
      <a-form-item
          :label="$t('editType')"
          name="edittype"
          :rules="[{ required: true, message: $t('pleaseSelect') + $t('editType') }]"
      >
        <select-id-and-name :list="editTypeList" option-value="id" option-text="name"
                            v-model:value="task.edittype" sort-by="id"></select-id-and-name>
      </a-form-item>
      <a-form-item
          :label="$t('other')"
          name="other"
          v-if="task.edittype === '07'"
      >
        <a-input v-model:value="task.otheredit"/>
      </a-form-item>
      <a-form-item
          :label="$t('description')"
          name="description"
      >
        <a-textarea v-model:value="task.description" :rows="4"/>
      </a-form-item>
      <a-form-item
          :label="$t('uploadFile')"
      >
        <cibr-file-upload :detail-id="task.id" @fileChange="changeFile"></cibr-file-upload>
      </a-form-item>
    </a-form>
  </a-modal>
  <v-loading :show="loading"></v-loading>
</template>

<script>
// zhouhan@cibr.ac.cn 2022/11/12 14:35
import VLoading from "@/components/public/v-loading";
import util from "@/util/util";
import SelectIdAndName from "@/components/public/selectIdAndName";
import CibrFileUpload from "@/components/public/cibrFileUpload";

export default {
  name: "editTask",
  components: {CibrFileUpload, SelectIdAndName, VLoading},
  props : {
    taskId : String
  },
  data() {
    return {
      loading: false,
      visible: false,
      task: {},
    }
  },
  mounted() {
  },
  methods: {
    handleOk() {
      this.$refs.taskForm.validate().then(() => {
        if (this.task.edittype === '07' && util.isNull(this.task.otheredit)){
          util.notificationError(this.$t("pleaseEnter") + this.$t("otherEditType"))
          return;
        }
        var post = {
          task : JSON.stringify(this.task)
        }
        util.$post("/task/edit/submit", post, () => {
          this.visible = false;
          util.submitSuccess();
          this.$emit("editSuccess")
        }, this.showMask, this.hideMask);
      })
    },
    changeFile(params) {
      this.task.fileList = params.fileList;
    },
    showModal() {
      this.visible = true;
      this.initPage();
    },
    showMask() {
      this.loading = true;
    },
    hideMask() {
      this.loading = false;
    },
    initPage() {
      var post = {
        taskId : this.taskId
      }
      util.$post("/task/edit/initPage", post, (res) => {
        this.task = res.task;
      }, this.showMask, this.hideMask);
    }
  },
  computed: {
    animalTypeList() {
      return util.animalTypeList();
    },
    editTypeList() {
      return util.editTypeList();
    },
    isAdmin(){
      return this.$store.getters.isGeneticAdmin;
    },
    canEdit(){
      if (this.isAdmin){
        return true;
      }
      if (this.task.status === "00"){
        return true;
      }
      return false;
    }
  }
}
</script>

<style scoped>
button{
  margin: 3px 3px;
}
</style>